import { ContextMenu } from 'primereact/contextmenu';
import { useContext } from 'react';
import { OverlayContext } from '../../OverlaysContext';
import { mainToolset, ToolsDispatchContext } from '../../ToolsContext';

export function MarkerContextMenu({cmRef, GStop}) {
    const toolDispatch = useContext(ToolsDispatchContext);
    const handleOverlay = useContext(OverlayContext);
    const cmItems = [
        {
          label: 'Edytuj przystanek',
          icon: 'fa-solid fa-pen-to-square',
          command: () => {
            toolDispatch({
                          type: 'changed',
                          newTool: {
                            ...mainToolset.tools.stopsTool,
                            selection: GStop.stop_id, // zaznacz przystanek na mapie
                            propertyEditor: {   // i wyświetl w edytorze
                              edit: GStop
                            }
                          },
                        });
          }
        },
        {
          label: 'Skopiuj koordynaty przystanku',
          icon: 'fa-solid fa-copy',
          command: async () => {
            const locationStr = GStop.stop_lat + ',' + GStop.stop_lon;
            try {
              await navigator.clipboard.writeText(locationStr);
              handleOverlay('toast', {
                severity: "success",
                summary: 'Pozycja skopiowana do schowka',
                detail: locationStr
              })
            } catch (error) {
              handleOverlay('toast', {
                severity: "error",
                summary: 'Kopiowanie nie udało się',
                detail: 'Możesz spróbować skopiować pozycję z tego okienka: \r\n ' + locationStr + '.\r\n Szczegóły błędu: ' + error.message
              })
            }
          } 
        }
      ];

    return (
        <ContextMenu ref={cmRef} model={cmItems}></ContextMenu>
    )
}